import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import Club from '../../icons/club.svg';
import Crm from '../../icons/crm.svg';
import Ecommerce from '../../icons/ecommerce.svg';
import Payments from '../../icons/payments.svg';
import PointOfSale from '../../icons/pos.svg';
import Reservations from '../../icons/reservations.svg';
import Section from '../Section';
import CtaLink from '../ui/CtaLink';

const SolutionsSection = (props) => {
  const { hide } = props;

  return (
    <StyledSection>
      <Title>All the solutions you need to deliver the right experience</Title>
      <SolutionsWrapper>
        {hide !== 'pos' && (
          <Solution to="/solutions/pos">
            <SolutionIcon>
              <PointOfSale />
            </SolutionIcon>
            <SolutionLabel>Point of Sale</SolutionLabel>
          </Solution>
        )}
        {hide !== 'club' && (
          <Solution to="/solutions/club">
            <SolutionIcon>
              <Club />
            </SolutionIcon>
            <SolutionLabel>Clubs &amp; Subscriptions</SolutionLabel>
          </Solution>
        )}
        {hide !== 'ecommerce' && (
          <Solution to="/solutions/ecommerce">
            <SolutionIcon>
              <Ecommerce />
            </SolutionIcon>
            <SolutionLabel>Ecommerce</SolutionLabel>
          </Solution>
        )}
        {hide !== 'crm' && (
          <Solution to="/solutions/crm">
            <SolutionIcon>
              <Crm />
            </SolutionIcon>
            <SolutionLabel>CRM</SolutionLabel>
          </Solution>
        )}
        {hide !== 'reservations' && (
          <Solution to="/solutions/reservations">
            <SolutionIcon>
              <Reservations />
            </SolutionIcon>
            <SolutionLabel>Reservations</SolutionLabel>
          </Solution>
        )}
        {hide !== 'payments' && (
          <Solution to="/solutions/payments">
            <SolutionIcon>
              <Payments />
            </SolutionIcon>
            <SolutionLabel>Payments</SolutionLabel>
          </Solution>
        )}
      </SolutionsWrapper>
      <CtaLink to="/solutions" color="var(--blue-base)">
        Explore the Commerce7 tools
      </CtaLink>
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  text-align: center;
  margin-bottom: 120px;
  background-image: url("data:image/svg+xml,%3Csvg width='329px' height='193px' viewBox='0 0 329 193' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EStars%3C/title%3E%3Cdefs%3E%3ClinearGradient x1='0%25' y1='50%25' x2='100%25' y2='50%25' id='linearGradient-1'%3E%3Cstop stop-color='%23072080' offset='0%25'%3E%3C/stop%3E%3Cstop stop-color='%23072080' offset='49.863063%25'%3E%3C/stop%3E%3Cstop stop-color='%23183BAE' offset='100%25'%3E%3C/stop%3E%3C/linearGradient%3E%3C/defs%3E%3Cg id='Pages---Home-&amp;-Solutions' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Home:-480' transform='translate(-20.000000, -5954.000000)' fill='url(%23linearGradient-1)'%3E%3Cg id='Solutions' transform='translate(0.000000, 5900.000000)'%3E%3Cg id='blueberry-stars' transform='translate(20.000000, 54.000000)'%3E%3Cpath d='M171.494286,44.1142857 C171.798831,44.1142857 172.045714,44.3611687 172.045714,44.6657143 L172.045143,46.3192857 L173.7,46.32 C174.004546,46.32 174.251429,46.566883 174.251429,46.8714286 C174.251429,47.1759742 174.004546,47.4228571 173.7,47.4228571 L172.045143,47.4222857 L172.045714,49.0771429 C172.045714,49.3816884 171.798831,49.6285714 171.494286,49.6285714 C171.18974,49.6285714 170.942857,49.3816884 170.942857,49.0771429 L170.942143,47.4222857 L169.288571,47.4228571 C168.984026,47.4228571 168.737143,47.1759742 168.737143,46.8714286 C168.737143,46.566883 168.984026,46.32 169.288571,46.32 L170.942143,46.3192857 L170.942857,44.6657143 C170.942857,44.3611687 171.18974,44.1142857 171.494286,44.1142857 Z' id='shape'%3E%3C/path%3E%3Cpath d='M325.894286,0 C326.198831,0 326.445714,0.246882981 326.445714,0.551428571 L326.445143,2.205 L328.1,2.20571429 C328.404546,2.20571429 328.651429,2.45259727 328.651429,2.75714286 C328.651429,3.06168845 328.404546,3.30857143 328.1,3.30857143 L326.445143,3.308 L326.445714,4.96285714 C326.445714,5.26740273 326.198831,5.51428571 325.894286,5.51428571 C325.58974,5.51428571 325.342857,5.26740273 325.342857,4.96285714 L325.342143,3.308 L323.688571,3.30857143 C323.384026,3.30857143 323.137143,3.06168845 323.137143,2.75714286 C323.137143,2.45259727 323.384026,2.20571429 323.688571,2.20571429 L325.342143,2.205 L325.342857,0.551428571 C325.342857,0.246882981 325.58974,0 325.894286,0 Z' id='shape' fill-rule='nonzero'%3E%3C/path%3E%3Cpath d='M46.8714286,168.737143 C47.1759742,168.737143 47.4228571,168.984026 47.4228571,169.288571 L47.4222857,170.942143 L49.0771429,170.942857 C49.3816884,170.942857 49.6285714,171.18974 49.6285714,171.494286 C49.6285714,171.798831 49.3816884,172.045714 49.0771429,172.045714 L47.4222857,172.045143 L47.4228571,173.7 C47.4228571,174.004546 47.1759742,174.251429 46.8714286,174.251429 C46.566883,174.251429 46.32,174.004546 46.32,173.7 L46.3192857,172.045143 L44.6657143,172.045714 C44.3611687,172.045714 44.1142857,171.798831 44.1142857,171.494286 C44.1142857,171.18974 44.3611687,170.942857 44.6657143,170.942857 L46.3192857,170.942143 L46.32,169.288571 C46.32,168.984026 46.566883,168.737143 46.8714286,168.737143 Z' id='shape'%3E%3C/path%3E%3Cpath d='M6.61714286,179.765714 C7.22623404,179.765714 7.72,180.25948 7.72,180.868571 L7.719,185.279714 L12.1314286,185.28 C12.7405198,185.28 13.2342857,185.773766 13.2342857,186.382857 C13.2342857,186.991948 12.7405198,187.485714 12.1314286,187.485714 L7.719,187.485714 L7.72,191.897143 C7.72,192.506234 7.22623404,193 6.61714286,193 C6.00805168,193 5.51428571,192.506234 5.51428571,191.897143 L5.514,187.485714 L1.10285714,187.485714 C0.493765962,187.485714 7.45921565e-17,186.991948 0,186.382857 C-7.45921565e-17,185.773766 0.493765962,185.28 1.10285714,185.28 L5.514,185.279714 L5.51428571,180.868571 C5.51428571,180.25948 6.00805168,179.765714 6.61714286,179.765714 Z' id='shape'%3E%3C/path%3E%3Cpath d='M242.077143,131.24 C242.381688,131.24 242.628571,131.486883 242.628571,131.791429 L242.628429,136.754 L247.591429,136.754286 C247.895974,136.754286 248.142857,137.001169 248.142857,137.305714 C248.142857,137.61026 247.895974,137.857143 247.591429,137.857143 L242.628429,137.857 L242.628571,142.82 C242.628571,143.124546 242.381688,143.371429 242.077143,143.371429 C241.772597,143.371429 241.525714,143.124546 241.525714,142.82 L241.525429,137.857 L236.562857,137.857143 C236.258312,137.857143 236.011429,137.61026 236.011429,137.305714 C236.011429,137.001169 236.258312,136.754286 236.562857,136.754286 L241.525429,136.754 L241.525714,131.791429 C241.525714,131.486883 241.772597,131.24 242.077143,131.24 Z' id='shape'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: 10% 12%;
  ${({ theme }) => `
    @media ${theme.mediumUp} {
      background-position: 20% 21%;
    }
  `}
`;

const Title = styled.h2`
  color: var(--blue-dark);
  font-size: var(--heading-size-base);
  font-weight: var(--font-weight-bold);
  margin-bottom: 50px;
  line-height: var(--line-height-base);
`;

const SolutionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  max-width: 1100px;
  margin: 0 auto 65px;
  background: white;
`;

const Solution = styled(Link)`
  width: 50%;
  margin-bottom: 30px;
  text-align: center;
  text-decoration: none;
  &:focus {
    outline: none;
  }
  ${({ theme }) => `
    @media ${theme.mediumUp} {
    width: calc(100% / 6);
    margin-bottom: 0;
    }
  `}
`;

const SolutionIcon = styled.div`
  width: 90px;
  height: 90px;
  border: 1px solid #dcdfe8;
  border-radius: 50%;
  box-shadow: 1px 2px 8px rgba(7, 32, 128, 0.08);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  transition: all 0.1s linear;
  ${Solution}:hover &, ${Solution}:focus & {
    transform: scale(1.05);
  }
`;

const SolutionLabel = styled.p`
  margin: 0;
`;

export default SolutionsSection;
